module.exports = __webpack_public_path__ + "img/5-2.5d29c332.jpg";